import { DateRangeOption } from '../schema/DateRangeOption';
import { assertNever } from 'owa-assert';
import strings from 'owa-strings/owa-mail-strings';

export function getTextLabelForOption(dateRangeOption: DateRangeOption): string {
    switch (dateRangeOption) {
        case DateRangeOption.Month:
            return strings.thisMonthDateRefiner;
        case DateRangeOption.Week:
            return strings.thisWeekDateRefiner;
        case DateRangeOption.CustomDateRange:
            return strings.selectRangeDateRefiner;
        case DateRangeOption.LastWeek:
            return strings.lastWeekDateRefiner;
        default:
            return assertNever(dateRangeOption);
    }
}
